// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const textAreaClasses = {
  counter: "qui-text-area__counter",
  errorText: "qui-text-area__error-text",
  hint: "qui-text-area__hint",
  input: "qui-text-area__input",
  label: "qui-text-area__label",
  requiredIndicator: "qui-text-area__required-indicator",
  root: "qui-text-area__root",
} as const
